// IELTS Mock 7 — Listening
// Same shape as IELTS_DATA_LISTENING in ../IeltsListening.js (4 parts, 40 questions,
// one audio track that plays once straight through). Recording script:
// client/scripts/ielts-audio/mock7-listeningScript.txt

// `audioStart` (seconds) is where each Part begins in the track; it comes from
// listeningTimings.json, which generate_neural.py rewrites with the audio.
import TIMINGS from "./listeningTimings.json";

const AUDIO_SRC = "/audio/ielts-mock7-listening.mp3";

const IELTS_MOCK7_LISTENING = {
  title: "IELTS Listening Mock 7",
  sections: [
    {
      id: "s1",
      audioStart: TIMINGS.partStarts[0],
      title: "Section 1: Holiday Cottage Booking",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Complete the notes below. Write ONE WORD AND/OR A NUMBER for each answer.",
          image: null,
          questions: [
            { id: "q1", text: "Surname: ______", type: "fill_blank", answer: "Whitcombe" },
            { id: "q2", text: "Arrival date: 12 ______", type: "fill_blank", answer: "September" },
            { id: "q3", text: "Length of stay: ______ nights", type: "fill_blank", answer: ["6", "six"] },
            { id: "q4", text: "Party: 2 adults and ______ children", type: "fill_blank", answer: ["2", "two"] },
            { id: "q5", text: "Cottage recommended: ______ Cottage", type: "fill_blank", answer: "Lavender" },
            { id: "q6", text: "Needs a ______ for the baby.", type: "fill_blank", answer: "cot" },
            { id: "q7", text: "Bringing a ______ (pet).", type: "fill_blank", answer: "dog" },
            { id: "q8", text: "Boat trip booked for ______.", type: "fill_blank", answer: "Thursday" },
            { id: "q9", text: "Contact number: ______", type: "fill_blank", answer: "07845330192" },
            { id: "q10", text: "Deposit to pay: £______", type: "fill_blank", answer: ["85", "£85"] },
          ],
        },
      ],
    },

    {
      id: "s2",
      audioStart: TIMINGS.partStarts[1],
      title: "Section 2: Willow Creek Adventure Park",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Choose the correct letter, A, B or C.",
          image: null,
          questions: [
            {
              id: "q11",
              text: "The park was built on the site of a former",
              type: "mcq",
              options: ["A. farm.", "B. quarry.", "C. railway."],
              answer: "B",
            },
            {
              id: "q12",
              text: "Which activity is the most popular overall?",
              type: "mcq",
              options: ["A. the zip wire", "B. the climbing wall", "C. the boat trip"],
              answer: "C",
            },
            {
              id: "q13",
              text: "What does the entry ticket include?",
              type: "mcq",
              options: ["A. lunch", "B. use of a locker", "C. equipment hire"],
              answer: "B",
            },
            {
              id: "q14",
              text: "What is the rule for children under eight?",
              type: "mcq",
              options: [
                "A. They must wear a helmet.",
                "B. They must be accompanied by an adult.",
                "C. They need a separate ticket.",
              ],
              answer: "B",
            },
            {
              id: "q15",
              text: "When are the activities usually quietest?",
              type: "mcq",
              options: [
                "A. first thing in the morning",
                "B. around lunchtime",
                "C. late in the afternoon",
              ],
              answer: "B",
            },
            {
              id: "q16",
              text: "What will be built next year?",
              type: "mcq",
              options: ["A. a hotel", "B. a bike trail", "C. a larger car park"],
              answer: "C",
            },
          ],
        },
        {
          instruction: "Label the map below. Write the correct letter, A–I, next to questions 17–20.",
          image: "/images/ielts-mock7/park_map.svg",
          mapOptions: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
          questions: [
            { id: "q17", text: "Visitor Centre", type: "map", answer: "A" },
            { id: "q18", text: "Café", type: "map", answer: "H" },
            { id: "q19", text: "Climbing Wall", type: "map", answer: "F" },
            { id: "q20", text: "Boat Hire", type: "map", answer: "E" },
          ],
        },
      ],
    },

    {
      id: "s3",
      audioStart: TIMINGS.partStarts[2],
      title: "Section 3: Campus Recycling Project",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Choose the correct letter, A, B or C.",
          image: null,
          questions: [
            {
              id: "q21",
              text: "Why did the students choose their topic?",
              type: "mcq",
              options: [
                "A. Their tutor recommended it.",
                "B. They had seen the problem themselves.",
                "C. It was in a recent news report.",
              ],
              answer: "B",
            },
            {
              id: "q22",
              text: "What was the problem with Tom's survey?",
              type: "mcq",
              options: [
                "A. Too few people replied.",
                "B. The questions were confusing.",
                "C. Some of the data was lost.",
              ],
              answer: "A",
            },
            {
              id: "q23",
              text: "What do they decide to do about the presentation?",
              type: "mcq",
              options: ["A. cut the introduction", "B. add a video", "C. use fewer slides"],
              answer: "C",
            },
            {
              id: "q24",
              text: "How does Maya feel about the group assessment?",
              type: "mcq",
              options: [
                "A. nervous about speaking in front of people",
                "B. worried about the time limit",
                "C. unsure about working as a team",
              ],
              answer: "A",
            },
          ],
        },
        {
          instruction:
            "What suggestion do the students make for each of the following? Choose SIX answers from the box A–H.",
          image: "/images/ielts-mock7/suggestion_options.svg",
          mapOptions: ["A", "B", "C", "D", "E", "F", "G", "H"],
          questions: [
            { id: "q25", text: "Recycling bins", type: "map", answer: "B" },
            { id: "q26", text: "Poster campaign", type: "map", answer: "E" },
            { id: "q27", text: "Café", type: "map", answer: "C" },
            { id: "q28", text: "Student union shop", type: "map", answer: "D" },
            { id: "q29", text: "Halls of residence", type: "map", answer: "G" },
            { id: "q30", text: "Website", type: "map", answer: "F" },
          ],
        },
      ],
    },

    {
      id: "s4",
      audioStart: TIMINGS.partStarts[3],
      title: "Section 4: Barn Owls",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Complete the notes below. Write ONE WORD ONLY for each answer.",
          image: null,
          questions: [
            { id: "q31", text: "Barn owls have a heart-shaped ______ that directs sound to their ears.", type: "fill_blank", answer: "face" },
            { id: "q32", text: "The feathers are very ______, so owls fly almost silently.", type: "fill_blank", answer: "soft" },
            { id: "q33", text: "They feed mainly on small ______, especially voles.", type: "fill_blank", answer: ["mammals", "mammal"] },
            { id: "q34", text: "They traditionally nest in hollow ______.", type: "fill_blank", answer: ["trees", "tree"] },
            { id: "q35", text: "The ______ brings food to the nest while the female sits on the eggs.", type: "fill_blank", answer: "male" },
            { id: "q36", text: "Chicks in the same nest differ considerably in ______.", type: "fill_blank", answer: "size" },
            { id: "q37", text: "The main threat is the loss of ______ where they hunt.", type: "fill_blank", answer: "grassland" },
            { id: "q38", text: "Many owls are killed in collisions with ______.", type: "fill_blank", answer: ["cars", "car"] },
            { id: "q39", text: "Conservation groups put up ______ boxes in barns and on poles.", type: "fill_blank", answer: "nest" },
            { id: "q40", text: "Landowners are asked to leave wide ______ at the edges of fields.", type: "fill_blank", answer: ["margins", "margin"] },
          ],
        },
      ],
    },
  ],
};

export default IELTS_MOCK7_LISTENING;
